import { render } from "./ViewImage.vue?vue&type=template&id=402b6544"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"
script.render = render

export default script